import Fetch from '../../../services/Fetch';
import { apiURL } from '../../../constants';

var getQueryString = function getQueryString(cnaeCodes) {
  var esc = encodeURIComponent;

  if (Array.isArray(cnaeCodes)) {
    return cnaeCodes.map(function (cnae) {
      return "".concat(esc('codes'), "=").concat(esc(cnae));
    }).join('&');
  }

  return "codes=".concat(cnaeCodes);
};

var convertSicForStore = function convertSicForStore(sicAndNaics) {
  sicAndNaics = Array.isArray(sicAndNaics) ? sicAndNaics : new Array(sicAndNaics);
  return sicAndNaics.filter(function (item) {
    return item.sic && item.sic.code;
  }).map(function (item) {
    var sic = item.sic;
    return {
      'value': sic.code,
      'label': sic.title_en || sic.title_es || sic.title_pt
    };
  });
};

var convertNaicsForStore = function convertNaicsForStore(sicAndNaics) {
  sicAndNaics = Array.isArray(sicAndNaics) ? sicAndNaics : new Array(sicAndNaics);
  return sicAndNaics.filter(function (item) {
    return item.naics && item.naics.code;
  }).map(function (item) {
    var naics = item.naics;
    return {
      'value': naics.code,
      'label': naics.title_en || naics.title_pt
    };
  });
};

var updateDependentFields = function updateDependentFields(fieldName, localValue, country, dispatchChangeForDependentFields) {
  if (localValue) {
    var query = getQueryString(localValue);
    Fetch.getJSON("".concat(apiURL.API_COMETA_SIC_NAICS, "?").concat(query, "&country=").concat(country)).then(function (sicAndNaicsCodes) {
      dispatchChangeForDependentFields(fieldName, sicAndNaicsCodes);
    }).catch(function (e) {
      return console.log(e);
    });
  }
};

export default {
  convertSicForStore: convertSicForStore,
  convertNaicsForStore: convertNaicsForStore,
  updateDependentFields: updateDependentFields
};